import { darken, styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.error300}`,
  backgroundColor: theme.palette.neutral000,
  color: theme.palette.error500,
  '&:hover': {
    backgroundColor: darken(theme.palette.neutral000, 0.1),
  },
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.neutral000} !important`,
    color: theme.palette.error300,
    borderColor: theme.palette.error100,
  },
  '& .MuiButton-endIcon': {
    margin: 0,
    '& > svg': {
      fontSize: '24px',
    },
  },
}))

export const ErrorOutlinedButton = createWithLoadingButton(StyledButton)
